import { Component, Input } from "@angular/core";

@Component({
  selector: "app-tpr-company",
  templateUrl: "./tpr-company.component.html",
  styleUrls: ["./tpr-company.component.scss"],
})
export class TprCompanyComponent {
  //inputs, outputs
  @Input() primaryTicker = "";
  @Input() isTabVisible;
}
